/**
 * Логика стяжки: вид по енаму и по id из ссылки каталога.
 */
import { screedSection } from "./catalog";
import { ScreedMaterial, type ScreedCatalogItem } from "./types";

export const DEFAULT_SCREED_MATERIAL: ScreedMaterial = ScreedMaterial.Dry;

/** Вид стяжки из каталога; неизвестный — первый. */
export const getScreedMaterial = (material: ScreedMaterial): ScreedCatalogItem =>
	screedSection.items.find((item) => item.material === material) ?? screedSection.items[0];

/** Вид по строковому id из ссылки каталога (`CatalogRef.item`). */
export const screedItemById = (id: string): ScreedCatalogItem | null =>
	screedSection.items.find((item) => item.id === id) ?? null;
